import { Builder } from '@builder.io/react';

import Quotes from './index';

Builder.registerComponent(Quotes, {
  name: 'Quotes',
  inputs: [
    {
      name: 'image',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'quotes',
      type: 'list',
      defaultValue: [
        {
          quote: {
            '@type': '@builder.io/core:Reference',
            id: '3534a042fecb43ae8f5aa8260f4f5c8a',
            model: 'quotes'
          }
        }
      ],
      subFields: [
        {
          name: 'quote',
          type: 'reference',
          model: 'quotes'
        }
      ]
    }
  ]
});
